var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSustainabilityShape4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 385.5 176.94"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SustainabilityShape4_svg__SustainabilityShape4Mask",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .862V.138C0 .062.029 0 .063 0h.873c.035 0 .063.062.063.138v.724C.999.938.97 1 .936 1H.063C.029 1 0 .938 0 .862"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzODUuNSAxNzYuOTQiPgoJPGRlZnM+CgkJPGNsaXBQYXRoIGlkPSJTdXN0YWluYWJpbGl0eVNoYXBlNE1hc2siIGNsaXBQYXRoVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94Ij4KCQkJPHBhdGgKCQkJCWQ9Ik0wLDAuODYyIFYwLjEzOCBDMCwwLjA2MiwwLjAyOSwwLDAuMDYzLDAgaDAuODczIGMwLjAzNSwwLDAuMDYzLDAuMDYyLDAuMDYzLDAuMTM4IHYwLjcyNCBjMCwwLjA3NiwtMC4wMjksMC4xMzgsLTAuMDYzLDAuMTM4IEgwLjA2MyBDMC4wMjksMSwwLDAuOTM4LDAsMC44NjIiCgkJCS8+CgkJPC9jbGlwUGF0aD4KCTwvZGVmcz4KPC9zdmc+Cg==";
export { SvgSustainabilityShape4 as ReactComponent };